import { createRoute, useEntityUrl } from 'framework/routing';
import { useParams } from 'react-router-dom';

export const PROCESS_INSTANCE_PATH = '/processes/instances';

export const useProcessInstanceRoute = () => {
  const routers = createRoute({ listRoute: PROCESS_INSTANCE_PATH });
  return {
    ...routers,
    historyRoute: `${routers.singleEntityRoute}/history`,
    issuesRoute: `${routers.singleEntityRoute}/issues`,
    variablesRoute: `${routers.singleEntityRoute}/variables`,
    subprocessesRoute: `${routers.singleEntityRoute}/subprocesses`,
    supportIssuesRoute: `${routers.singleEntityRoute}/support`,
    tokenModificationsRoute: `${routers.singleEntityRoute}/token-modifications`,
    incidentsRoute: `${routers.singleEntityRoute}/incidents`,
    tracingRoute: `${routers.singleEntityRoute}/tracing`,
  };
};

export const useProcessInstanceUrl = () => {
  const { getSingleEntityUrl, ...rest } = useEntityUrl({ baseLink: PROCESS_INSTANCE_PATH });
  const getHistoryUrl = (id?: string): string => `${getSingleEntityUrl(id)}/history`;
  const getIssuesUrl = (id: string): string => `${getSingleEntityUrl(id)}/issues`;
  const getSubprocessesUrl = (id: string): string => `${getSingleEntityUrl(id)}/subprocesses`;
  const getSupportIssuesUrl = (id: string): string => `${getSingleEntityUrl(id)}/support`;
  const getVariablesUrl = (id?: string, context?: string): string => {
    return `${getSingleEntityUrl(id)}/variables${context ? `?context=${context}` : ''}`;
  };
  const getTokenModificationsUrl = (id: string): string => `${getSingleEntityUrl(id)}/token-modifications`;
  const getIncidentsUrl = (id: string): string => `${getSingleEntityUrl(id)}/incidents`;
  const getTracingUrl = (id: string): string => `${getSingleEntityUrl(id)}/tracing`;

  return {
    getSingleEntityUrl,
    ...rest,
    getHistoryUrl,
    getIssuesUrl,
    getVariablesUrl,
    getSubprocessesUrl,
    getSupportIssuesUrl,
    getTokenModificationsUrl,
    getIncidentsUrl,
    getTracingUrl,
  };
};

export const useProcessInstanceId = () => useParams<Dictionary<string>>().id!;
